import { resetPasswordLegacyTokenPrefix, resetPasswordTokenPrefix } from 'common/config/urls';

export const normalizePasswordResetUrl = (value: string) => {
  const normalizedValue = value.startsWith('/') ? value : `/${value}`;
  return normalizedValue.replace(`${resetPasswordLegacyTokenPrefix}/`, `${resetPasswordTokenPrefix}/`);
};
